import { LEGACY_URL } from 'config'
import { ajax } from 'rxjs/ajax'
import { accessTokenSelector } from 'services/users/selectors'
import { StoreThunkDispatch, getState } from 'store/state'

export const ENDPOINT_LEGACY_LOGOUT = `${LEGACY_URL}/login/logout_v3`

export const V1 = Object.freeze({
  logout: function () {

    return function (token: string) {
      return () => ajax({
        url: `${ENDPOINT_LEGACY_LOGOUT}?access_token=${encodeURIComponent(token)}`,
        method: 'POST',
        headers: {
          Accept: 'application/vnd.postplanner.v2+json'
        },
        crossDomain: true,
        withCredentials: true
      })
    }
  }()
})

export function legacyLogout(accessToken?: string) {
  return (dispatch: StoreThunkDispatch, getState: getState) => {
    const token = accessToken || accessTokenSelector(getState())
    return dispatch(V1.logout(token || ''))
  }
}
